import { Checkbox, Input } from 'antd';

export const getTableColumnsIDSO = (onCheckChange, onFilterChange, filters, onEnterPress) => [
  {
    title: 'Selecciona',
    dataIndex: 'selecciona',
    align: 'center',
    width: '12%',
    key: 'selecciona',
    render: (value, row) => (
      <Checkbox checked={value} onChange={(e) => onCheckChange(row, e.target.checked)} />
    )
  },
  {
    title: 'ID Beneficiado',
    dataIndex: 'idBeneficiado',
    width: '12%',
    key: 'idBeneficiado'
  },
  {
    title: (
      <div>
        <div>Nombre del Beneficiado</div>
        <Input
          value={filters?.nombreBeneficiado}
          onChange={(e) => onFilterChange('nombreBeneficiado', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'nombreBeneficiado',
    width: '20%',
    key: 'nombreBeneficiado'
  },
  {
    title: 'Sujeto Obligado',
    dataIndex: 'sujetoObligado',
    width: '15%',
    key: 'sujetoObligado'
  },
  {
    title: (
      <div>
        <div>Cargo</div>
        <Input
          value={filters?.cargo}
          onChange={(e) => onFilterChange('cargo', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'cargo',
    width: '15%',
    key: 'cargo'
  },
  {
    title: (
      <div>
        <div>Entidad</div>
        <Input
          value={filters?.estado}
          onChange={(e) => onFilterChange('estado', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'estado',
    width: '15%',
    key: 'estado'
  },
  {
    title: (
      <div>
        <div>Tipo de Beneficio</div>
        <Input
          value={filters?.tipoBeneficio}
          onChange={(e) => onFilterChange('tipoBeneficio', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'tipoBeneficio',
    width: '14%',
    key: 'tipoBeneficio'
  },
  {
    title: (
      <div>
        <div>Folio de Monitoreo</div>
        <Input
          value={filters?.folio}
          onChange={(e) => onFilterChange('folio', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'folio',
    width: '17%',
    key: 'folio'
  },
  {
    title: 'ID de Hallazgo',
    dataIndex: 'idHallazgo',
    width: '15%',
    key: 'idHallazgo'
  }
];

export const getTableColumnsCandidatosAprobados = (
  onCheckChange,
  onFilterChange,
  filters,
  onEnterPress
) => [
  {
    title: 'Asociar',
    dataIndex: 'asociar',
    align: 'center',
    width: '8%',
    key: 'asociar',
    render: (value, row) => (
      <Checkbox checked={value} onChange={(e) => onCheckChange(row, e.target.checked)} />
    )
  },
  {
    title: 'Identificador SO',
    dataIndex: 'idSujetoObligado',
    width: '11%',
    key: 'idSujetoObligado'
  },
  {
    title: 'Tipo Asociación',
    dataIndex: 'tipoAsociacion',
    width: '15%',
    key: 'tipoAsociacion'
  },
  {
    title: (
      <div>
        <div>Nombre Candidata/o</div>
        <Input
          value={filters.nombreCandidato}
          onChange={(e) => onFilterChange('nombreCandidato', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'nombreCandidato',
    width: '20%',
    key: 'nombreCandidato'
  },
  {
    title: 'Sujeto Obligado',
    dataIndex: 'sujetoObligado',
    width: '15%',
    key: 'sujetoObligado'
  },
  {
    title: (
      <div>
        <div>Cargo</div>
        <Input
          value={filters?.cargo}
          onChange={(e) => onFilterChange('cargo', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'cargo',
    width: '15%',
    key: 'cargo'
  },
  {
    title: (
      <div>
        <div>Entidad</div>
        <Input
          value={filters.estado}
          onChange={(e) => onFilterChange('estado', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'estado',
    width: '15%',
    key: 'estado'
  },
  {
    title: (
      <div>
        <div>Cuenta RF</div>
        <Input
          value={filters.cuentaRF}
          onChange={(e) => onFilterChange('cuentaRF', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'cuentaRF',
    width: '14.25%',
    key: 'cuentaRF'
  },
  {
    title: (
      <div>
        <div>Correo RF</div>
        <Input
          value={filters.correoRF}
          onChange={(e) => onFilterChange('correoRF', e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onEnterPress()}
          size="small"
          placeholder="Filtra"
        />
      </div>
    ),
    dataIndex: 'correoRF',
    width: '14.25%',
    key: 'correoRF'
  }
];
